import type { Lang, ReservationStatus } from '../data/types';
import { t } from '../i18n/t';
import { STATUS } from './helpers';

interface PillProps {
  status: ReservationStatus;
  lang: Lang;
}

/** Status pill — coloured tint background + matching dot. */
export function Pill({ status, lang }: PillProps) {
  const s = STATUS[status] ?? STATUS.conf;
  return (
    <span className={`pill ${s.cls}`}>
      <span className="dot" aria-hidden="true" />
      {t(s.key, lang)}
    </span>
  );
}
